<template>
  <div>
    <div class="renewing-membership membership-options confirm-electoral">
      <div class="row">
        <div class="col-md-12 ">
          <h6>{{ configOptions['renewal-label-confirm-address'] }}</h6>
          <el-form
            class="address-form"
            label-position="top"
            ref="address-info-form"
            :model="addressInfo"
            :rules="formValidation"
            v-loading="validating"
            target="address-form"
            element-loading-text="Updating details..."
          >
            <el-dialog class="disclosure-content" :visible.sync="disclosureState">
              <div v-html="contentDisclosureAddress" />
            </el-dialog>

            <el-row>
              <div class="validation-error" v-if="validateResult.toLowerCase() === 'invalid'">
                <img class="edit-ico" src="../../assets/icons/warning.svg" alt="">
                <div class="content">
                  <h3>Verification Failed.</h3>
                  <p>
                    Failed to verify your address based on Australian Electoral Roll. <br>
                    <strong>Try again</strong> or get in touch with us on <a href="tel:0283560300">(02) 8356 0300</a>
                  </p>
                </div>
                <i class="el-icon-close" @click="validateResult = 'valid'"></i>
              </div>

              <el-form-item>
                <p>{{ formLabel }}</p>
                <el-form-item prop="address">
                  <el-input
                    id="address-autocomplete"
                    v-model="addressInfo.address_1"
                    prefix-icon="el-icon-search"
                    @input="searchQuery"
                    @focus="showAddressLists = true"
                    @clear="showAddressLists = false"
                    clearable
                    placeholder="Enter your Address"
                  ></el-input>
                  <div v-if="showAddressLists" class="custom-dropwndown el-select-dropdown el-popper" v-loading="loading">
                    <ul class="el-scrollbar__view el-select-dropdown__list">
                      <li class="el-select-dropdown__item" v-for="(item,i) in searchResult" :key="i" @click="onSelectAddress(item.description)">
                        {{ item.description }}
                      </li>
                      <li class="el-select-dropdown__item hover" @click="showAddressLists = false">close</li>
                    </ul>
                  </div>
                </el-form-item>
              </el-form-item>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item prop="suburb" :inline-message="true">
                  <p>Suburb</p>
                  <el-input v-model="addressInfo.suburb" placeholder="Enter" @change="edit = true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="state" :inline-message="true">
                  <p>State</p>
                  <el-select v-model="addressInfo.state" placeholder="Select" @change="edit = true">
                    <el-option
                      v-for="(state, i) in donationOptions['state-list']['items']"
                      :key="i"
                      :label="state['state-name']"
                      :value="state['state-name']"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="postcode" :inline-message="true">
                  <p>Postcode</p>
                  <el-input v-model="addressInfo.post_code" placeholder="Enter" @change="edit = true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :inline-message="true" prop="mobileNumber">
                  <p>Mobile number</p>
                  <el-input prefix-icon="el-icon-phone" v-model="addressInfo.mobileNumber" placeholder="Mobile number" @change="edit = true"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :inline-message="true" prop="email">
                  <p>Email address</p>
                  <el-input prefix-icon="el-icon-message" v-model="addressInfo.email" placeholder="name@email.com" @change="edit = true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row class="disclosure-row">
              <el-form-item prop="checked" :inline-message="true" size="mini">
                <el-checkbox @change="disclosureState = false " v-model="addressInfo.checked" name="disclosure">
                  <span v-html="configOptions['renewal-label-disclosure-address']" />
                  <a href="#" class="font-weight-bold" @click="disclosureState = true">{{ configOptions['renewal-link-disclosure-address'] }}</a>
                </el-checkbox>
              </el-form-item>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <div class="renewal-btn d-flex flex-wrap" v-if="!validating">
      <el-button type="secondary" @click="setStep(2)"><i class="el-icon-back"></i> BACK</el-button>
      <el-button type="primary" @click="nextStep">NEXT <i class="el-icon-arrow-right el-icon-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapMutations, mapActions } from "vuex";

import {addressParser} from "@helpers/addressParser";

export default {
  data() {
    const validateNumber = (rule, value, callback) => {
        const reg = /^(?=.*\d)[\d ]+$/
        if (value && !reg.test(value)) {
          return callback(new Error('Please input digits'));
        } else {
          return  callback();
        }
    }
    const validateEmail = (rule, value, callback) => {
      const re = /\S+@\S+\.\S+/;
      if (value && re.test(value) === false) {
        return callback(
          new Error(
            this.donationOptions["validation-contact-form"]["invalid-email-address"]
          )
        );
      } else {
        callback();
      }
    };

    return {
      showAddressLists: false,
      disclosureState: false,
      loading: false,
      validating: false,
      validateResult: '',
      edit: false,
      firstName: "",
      lastName: "",
      searchResult: [],
      addressInfo: {
        addressFull: "",
        address_1: "",
        suburb: "",
        state: "",
        post_code: "",
        mobileNumber: "",
        email: "",
        checked: []
      },
      formValidation: {
        address_1: {
          required: true,
          message: "",
          trigger: "change"
        },
        suburb: {
          required: true,
          message: "",
          trigger: "change"
        },
        post_code: {
          required: true,
          message: "",
          trigger: "change"
        },
        state: {
          required: true,
          message: "",
          trigger: "change"
        },
        mobileNumber: [
          {
            validator: validateNumber,
            trigger: 'blur'
          }
        ],
        email: {
          validator: validateEmail,
          trigger: "blur"
        },
        checked: {
          type: 'array',
          required: true,
          message: "You must read and accept our rules before you can proceed",
          trigger: "change"
        }
      }
    };
  },
  watch: {
    addressInfo()  {
      this.invalidUser = false
    },
    searchResult() {
      console.log(this.searchResult)
    }
  },
  computed: {
    ...mapGetters('renewal', ['configOptions', 'donationOptions', 'jnrProduct', 'userInfo']),
    formLabel() {
      return "Electoral Roll Address"
    },
    contentDisclosureAddress() {
      const configProp = `renewal-content-disclosure-address${this.jnrProduct ? '-jnr' : ''}`;
      return this.configOptions[configProp];
    }
  },
  methods: {
    ...mapMutations('renewal', ['setStep', 'setPayload']),
    ...mapActions('renewal', ['updateContactElectoral']),

    async onSelectAddress(address) {

      const {addressFull, streetAddress, suburb, state, postcode } = await addressParser.parseAddress(address)

      this.addressInfo.addressFull = addressFull
      this.addressInfo.address_1 = streetAddress
      this.addressInfo.suburb = suburb
      this.addressInfo.state = state
      this.addressInfo['post_code'] = postcode

      this.showAddressLists = false;

      this.edit = true;
    },
    searchQuery: _.debounce(async function(query) {
      if (!query) return

      try {
        this.loading = true
        this.searchResult = await addressParser.addressLookup(query)
        this.showAddressLists = !!this.searchResult.length

      } catch (error) {
        console.log('')
      } finally {
        this.loading = false
      }
    }, 100),
    nextStep() {
      this.$refs["address-info-form"].validate(valid => {
        if (valid) {
          if (this.edit) {
            const newAddress = {
              ...this.userInfo.address,
              address_1: this.addressInfo.address_1,
              suburb: this.addressInfo.suburb,
              state: this.addressInfo.state,
              post_code: this.addressInfo.post_code,
            };
            this.setPayload({ donorInfo: { address: newAddress, email: this.addressInfo.email, mobile: this.addressInfo.mobileNumber }});

            this.validateElectoralAddress();
          } else {
            this.setStep(4);
          }
        }
      });
    },

    setValidationMessage() {
      this.formValidation.address_1.message = this.donationOptions["validation-contact-form"]["missing-address"];
      this.formValidation.suburb.message = this.donationOptions["validation-contact-form"]["missing-suburb"];
      this.formValidation.state.message = this.donationOptions["validation-contact-form"]["missing-suburb"];
      this.formValidation.post_code.message = this.donationOptions["validation-contact-form"]["missing-postcode"];
    },
    autoFillAddress() {
      this.addressInfo.address_1 = this.userInfo.address.address_1
      this.addressInfo.suburb = this.userInfo.address.suburb
      this.addressInfo.state = this.userInfo.address.state
      this.addressInfo.post_code = this.userInfo.address.post_code
      this.addressInfo.addressFull = `${this.addressInfo.address_1}, ${this.addressInfo.suburb} ${this.addressInfo.state}, ${this.addressInfo.post_code}`
      this.addressInfo.mobileNumber = this.userInfo.mobile
      this.addressInfo.email = this.userInfo.email
    },
    validateElectoralAddress() {
      this.validating = true;

      this.updateContactElectoral().then((res) => {
        this.validateResult = res.toLowerCase();
        this.validating = false
        if(this.validateResult === 'valid') {
          this.setStep(4);
        }
      });
    }
  },
  mounted() {
    this.setValidationMessage();
    this.autoFillAddress()
  }
};
</script>

<style lang="scss" scoped>
.custom-dropwndown {
  width: 100%;
}

.disclosure-content {
  div {
    word-break: break-word;
  }

  .el-dialog {
    width: 90%;
    @media (min-width: 640px) {
      width: 70%;
    }

    @media (min-width: 1280px) {
      width: 35%;
    }
  }
}

.disclosure-row {
  display: flex;

  .disclosure {
    color: #3598ff;
    font-weight: bold;

    cursor: pointer;
    margin-left: 5px;
    transform: translate(0, 1px);
  }
}

.validation-error {
  position: relative;

  display: flex;
  align-items: flex-start;

  background: rgba(211, 35, 35, 0.06);
  border-radius: 4px;
  padding: 16px;

  margin-bottom: 20px;

  .el-icon-close {
    position: absolute;
    top: 18px;
    right: 15px;

    cursor: pointer;
  }

  img {
    width: 20px;
    height: 20px;
  }

  .content {
    margin-left: 12px;

    h3,p {
      color: #414042;
    }

    h3{
      margin: 0;

      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
    }

    p {
      font-size: 15px;
      line-height: 24px;
    }

    a {
      color: #00529b;
      font-weight: bold;
    }
  }
}
.remote-address {
  .el-form-item__content {
    .el-input {
      .el-input__inner {
        padding-left: 29px;
      }
    }
    .el-icon-search {
      position: absolute;
      top: 17px;
      left: 9px;
      color: #c8cbd3;
    }
  }
}
.el-date-editor.el-input {
  width: auto;
}
.address-form {
  .el-row {
    margin-bottom: 16px;
  }

  .el-select {
    width: 100%;
  }

  .donor {
    display: flex;
    justify-content: space-between;
    align-items: center;

    background: #f5f5f5;
    padding: 1px 14px;
    border-radius: 2px;

    p {
      font-weight: bold;
      text-transform: capitalize;
    }
  }
}
</style>
